import { render, staticRenderFns } from "./Packing.vue?vue&type=template&id=65273e81&"
import script from "./Packing.vue?vue&type=script&lang=js&"
export * from "./Packing.vue?vue&type=script&lang=js&"
import style0 from "./Packing.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports